module.exports = __webpack_public_path__ + "img/icon-1-2.db53aaf9.png";